import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-form-errors',
    templateUrl: './form.errors.component.html',
    standalone: false
})
export class FormErrorsComponent {
  @Input() public errors: any;
}
